import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AddDefectCompliance, DefectDto } from 'src/app/control/model/control.model';
import { addDefectCompliance } from 'src/app/control/store/control.action';
import { extendTextArea } from 'src/app/shared/style';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ControlDefectItemComponent } from '../control-defect-item/control-defect-item.component';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatChipListbox } from '@angular/material/chips';
import { TagComponent } from '../../shared/components/chips/tag/tag.component';
import { DarkButtonComponent } from '../../shared/buttons/dark-button.component';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { ValidateButtonComponent } from '../../shared/buttons/validate-button.component';

@Component({
  selector: 'sibat-control-defect-compliance-form',
  templateUrl: 'control-defect-compliance-form.component.html',
  styleUrls: ['control-defect-compliance-form.component.scss'],
  imports: [
    TranslocoDirective,
    ControlDefectItemComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatError,
    MatChipListbox,
    TagComponent,
    DarkButtonComponent,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    ValidateButtonComponent,
    TranslocoPipe,
  ],
})
export class ControlDefectComplianceFormComponent implements OnInit {
  @Input() controlId: number;
  @Input() defects: DefectDto[];
  @Input() thumbnails: Record<string, string>;

  complianceForm = this.formBuilder.group(
    {
      files: [[]],
      description: '',
      date: new Date(),
    },
    { validators: this.checkProofsValidator }
  );

  constructor(private store: Store, private formBuilder: UntypedFormBuilder) {}

  checkProofsValidator(group: UntypedFormGroup) {
    const description: string = group.controls.description.value;
    const files: File[] = group.controls.files.value;
    return files.length > 0 || !!description.length ? null : { missing: true };
  }

  addFiles(fileList: FileList): void {
    const selectedFiles: File[] = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < fileList.length; i++) {
      selectedFiles.push(fileList[i]);
    }

    const currentFiles = this.complianceForm.get('files')?.value as File[];
    this.complianceForm.patchValue({
      files: [...currentFiles, ...selectedFiles],
    });
  }

  removeFile(fileToRemove: File): void {
    const currentFiles = this.complianceForm.get('files')?.value as File[];
    this.complianceForm.patchValue({
      files: currentFiles.filter(file => file !== fileToRemove),
    });
  }

  extendTextArea(element) {
    extendTextArea(element);
  }

  saveDefectCompliance() {
    if (!this.complianceForm.valid) {
      return;
    }
    const defectIds: number[] = this.defects.map(defect => defect.id);
    const form: AddDefectCompliance = {
      controlId: this.controlId,
      defectIds,
      date: this.complianceForm.get('date')?.value,
      description: this.complianceForm.get('description')?.value,
      files: this.complianceForm.get('files')?.value,
    };
    this.store.dispatch(addDefectCompliance({ form }));
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.resizeTextareas();
    }, 100);
  }

  resizeTextareas() {
    const textareas = document.querySelectorAll('textarea[formControlName="description"]');
    textareas.forEach(textarea => this.extendTextArea(textarea));
  }
}
